import { CartUpdatedEvent } from '@theme/events';

/**
 * Interrupteur « Shipping Protection » du tiroir panier.
 * Coché   -> ajoute la variante au panier
 * Décoché -> retire la ligne correspondante
 * Dans les deux cas, la section du panier est re-rendue par Shopify,
 * donc l'état de l'interrupteur est toujours recalculé côté serveur.
 */
class ShippingProtection extends HTMLElement {
  connectedCallback() {
    this.input = this.querySelector('[data-ref="shipping-protection-input"]');
    this.input?.addEventListener('change', this.#onChange);
  }

  disconnectedCallback() {
    this.input?.removeEventListener('change', this.#onChange);
  }

  get #sections() {
    const list = ['auto-gifts'];
    const drawerId = document.querySelector('cart-drawer')?.dataset.sectionId;
    if (drawerId) list.push(drawerId);
    return list.join(',');
  }

  #onChange = (event) => {
    if (event.target.checked) {
      this.#add();
    } else {
      this.#remove();
    }
  };

  #loading(state) {
    this.classList.toggle('shipping-protection--loading', state);
    if (this.input) this.input.disabled = state;
  }

  async #add() {
    this.#loading(true);
    try {
      const response = await fetch(Theme.routes.cart_add_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{ id: Number(this.dataset.variantId), quantity: 1 }],
          sections: this.#sections,
        }),
      });
      const data = await response.json();
      if (data.status && data.status >= 400) throw new Error(data.description || data.message);
      this.#notify(data.sections, 'shipping-protection-add');
    } catch (error) {
      console.error('ShippingProtection: ajout impossible', error);
      if (this.input) this.input.checked = false;
    } finally {
      this.#loading(false);
    }
  }

  async #remove() {
    this.#loading(true);
    try {
      // On relit le panier pour retrouver la ligne exacte (l'index peut avoir bougé).
      const cart = await (await fetch(`${Theme.routes.cart_url}.js`)).json();
      const variantId = Number(this.dataset.variantId);
      const line = cart.items.findIndex((item) => item.variant_id === variantId) + 1;

      if (line === 0) {
        this.#loading(false);
        return;
      }

      const response = await fetch(Theme.routes.cart_change_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          line,
          quantity: 0,
          sections: this.#sections,
          sections_url: window.location.pathname,
        }),
      });
      const data = await response.json();
      if (data.errors) throw new Error(JSON.stringify(data.errors));
      this.#notify(data.sections, 'shipping-protection-remove');
    } catch (error) {
      console.error('ShippingProtection: retrait impossible', error);
      if (this.input) this.input.checked = true;
    } finally {
      this.#loading(false);
    }
  }

  #notify(sections, source) {
    if (window.location.pathname.includes('/cart')) {
      window.location.reload();
      return;
    }
    document.dispatchEvent(new CartUpdatedEvent({}, { source, sections }));
  }
}

if (!customElements.get('shipping-protection')) {
  customElements.define('shipping-protection', ShippingProtection);
}
